module.exports = __webpack_public_path__ + "img/yfs.1555ee81.png";